/**
 * Transform booking parts into a a group of refundable rooms for an accommodation.
 */
export function transformRefundableGroupsAccommodation(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']) {
    const apiBooking = response?.booking;
    if (!apiBooking) {
        return [];
    }

    return bookingParts
        .filter(bp => bp.objectType === 'Accommodation')
        .reduce<RefundableGroupAccommodation[]>((list, bookingPart) => {
            assignAccommodation(list, bookingPart, apiBooking);
            return list;
        }, []);
}

/**
 *
 */
function assignAccommodation(
    list: RefundableGroupAccommodation[],
    accommodation: ApiSchema['Accommodation'],
    apiBooking: ApiSchema['Booking'],
) {
    const type = 'Accommodation';
    const id = accommodation.accommodationDetails?.id ?? '';
    const refundable = transformRefundableAccommodation(accommodation, apiBooking);

    let refundableGroup = list
        .filter(p => p.type === type)
        .find(p => p.id === id);
    if (!refundableGroup) {
        refundableGroup = {
            id,
            type,
            refundables: [],
        } satisfies RefundableGroupAccommodation;
        list.push(refundableGroup);
    }

    refundableGroup.refundables.push(refundable);
}
